var cfg = {
	endpoint: "",
	appId: "",
	env: "",
	cdnUrl: "",
	// 默认只开启 JS、Promise、资源错误
	enable: {
		jsError: true,
		promiseRejection: true,
		resourceError: true,
		apiError: true,
	},
	// 忽略规则
	ignoreErrors: [],
	ignoreResources: [],
	ignoreDomains: [], // 新增：忽略域名列表
	ignoreStatusCodes: [], // 新增：忽略的状态码
};

// 辅助函数
function now() {
	return Date.now();
}
function isCdn(u) {
	var c = cfg.cdnUrl;
	if (!c || !u) return false;
	try {
		var a = new URL(u, typeof location !== "undefined" ? location.origin : "http://localhost");
		var b = new URL(c, typeof location !== "undefined" ? location.origin : "http://localhost");
		var base = b.href.replace(/\/$/, "");
		return a.hostname === b.hostname || a.href.indexOf(base + "/") === 0;
	} catch (e) {
		return false;
	}
}
function isIgnoredError(msg) {
	if (!msg) return false;
	var arr = cfg.ignoreErrors || [];
	for (var i = 0; i < arr.length; i++) {
		var r = arr[i];
		if (typeof r === "string" && msg.indexOf(r) >= 0) return true;
		if (r && r.test && r.test(msg)) return true;
	}
	return false;
}
function isIgnoredResource(u) {
	if (!u) return false;
	var arr = cfg.ignoreResources || [];
	for (var i = 0; i < arr.length; i++) {
		var r = arr[i];
		if (typeof r === "string" && u.indexOf(r) >= 0) return true;
		if (r && r.test && r.test(u)) return true;
	}
	return false;
}
// 新增：判断域名是否需要忽略
function isIgnoredDomain(u) {
	if (!u) return false;
	var arr = cfg.ignoreDomains || [];
	if (arr.length === 0) return false;

	try {
		// 尝试解析 URL 获取 hostname
		var hostname = "";
		if (u.indexOf("http") === 0 || u.indexOf("//") === 0) {
			var urlObj = new URL(
				u,
				typeof location !== "undefined" ? location.origin : "http://localhost"
			);
			hostname = urlObj.hostname;
		} else {
			// 相对路径，通常是本站，不忽略，除非明确配置了本站域名
			hostname = typeof location !== "undefined" ? location.hostname : "";
		}

		for (var i = 0; i < arr.length; i++) {
			var r = arr[i];
			if (typeof r === "string") {
				// 字符串匹配：如果是子串或精确匹配
				if (hostname.indexOf(r) >= 0) return true;
			}
			if (r && r.test && r.test(hostname)) return true;
		}
	} catch (e) {}

	return false;
}

// 新增：检查内容是否包含被忽略的域名（用于检查 stack 或 message）
function isIgnoredByContent(content) {
	if (!content) return false;
	var arr = cfg.ignoreDomains || [];
	for (var i = 0; i < arr.length; i++) {
		var r = arr[i];
		if (typeof r === "string") {
			// 字符串匹配
			if (content.indexOf(r) >= 0) return true;
		}
		// 正则匹配
		if (r && r.test && r.test(content)) return true;
	}
	return false;
}

// 新增：判断状态码是否需要忽略
function isIgnoredStatus(status) {
	var arr = cfg.ignoreStatusCodes || [];
	return arr.indexOf(status) >= 0;
}

// 格式化错误信息为字符串
function formatMessage(item) {
	var msg = "";
	var locationHref = typeof location !== "undefined" ? location.href : "";

	if (item.type === "js_error") {
		msg =
			"[JS Error] " +
			(item.payload.message || "") +
			"\nFile: " +
			(item.payload.filename || "") +
			"\nLine: " +
			(item.payload.lineno || "") +
			":" +
			(item.payload.colno || "") +
			"\nUrl: " +
			locationHref +
			"\nStack: " +
			(item.payload.stack || "");
	} else if (item.type === "promise_rejection") {
		msg =
			"[Promise Error] " +
			(item.payload.message || "") +
			"\nUrl: " +
			locationHref +
			"\nStack: " +
			(item.payload.stack || "");
	} else if (item.type === "resource_error") {
		msg =
			"[Resource Error] " +
			(item.payload.src || "") +
			"\nTag: " +
			(item.payload.tag || "") +
			"\nCDN: " +
			(item.payload.cdn ? "Yes" : "No") +
			"\nUrl: " +
			locationHref;
	} else if (item.type === "api_error") {
		msg =
			"调用" +
			(item.payload.method || "GET") +
			" - " +
			(item.payload.url || "") +
			" - 失败" +
			"\nbody:" +
			(item.payload.body || "") +
			"\n返回：" +
			(item.payload.response || "") +
			"\nStatus: " +
			(item.payload.status || 0) +
			"\nDuration: " +
			(item.payload.duration || 0) +
			"ms" +
			"\nUrl: " +
			locationHref;
	} else {
		msg = "[" + item.type + "] " + JSON.stringify(item.payload) + "\nUrl: " + locationHref;
	}
	return msg;
}

// 发送函数 (application/x-www-form-urlencoded)
function send(item) {
	if (!cfg.endpoint) return;

	var message = formatMessage(item);
	var body = "name=" + encodeURIComponent(cfg.appId) + "&message=" + encodeURIComponent(message);

	try {
		if (typeof fetch !== "undefined") {
			fetch(cfg.endpoint, {
				method: "POST",
				headers: {
					"Content-Type": "application/x-www-form-urlencoded",
				},
				body: body,
				keepalive: true,
			}).catch(function () {});
			return;
		}
	} catch (e) {}

	try {
		var xhr = new XMLHttpRequest();
		xhr.open("POST", cfg.endpoint, true);
		xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
		xhr.send(body);
	} catch (e) {}
}

function push(type, payload) {
	var item = { type: type, ts: now(), payload: payload || {} };
	// 实时发送，不批量
	send(item);
}

function hookFetch() {
	if (typeof window.fetch !== "function") return;
	var originalFetch = window.fetch;
	window.fetch = function (input, init) {
		var url = typeof input === "string" ? input : input.url;

		// 排除上报接口，避免死循环
		if (url && cfg.endpoint && url.indexOf(cfg.endpoint) !== -1) {
			return originalFetch.apply(this, arguments);
		}

		// 域名过滤
		if (isIgnoredDomain(url)) {
			return originalFetch.apply(this, arguments);
		}

		var method = (init && init.method) || "GET";
		var body = (init && init.body) || "";
		var startTime = now();

		return originalFetch
			.apply(this, arguments)
			.then(function (response) {
				if (!response.ok) {
					// 忽略特定状态码
					if (isIgnoredStatus(response.status)) return response;

					// 捕获 HTTP 错误
					var clone = response.clone();
					clone.text().then(function (text) {
						push("api_error", {
							type: "fetch",
							url: url,
							method: method,
							body: typeof body === "string" ? body : "[object Object]",
							status: response.status,
							statusText: response.statusText,
							response: text,
							duration: now() - startTime,
						});
					});
				}
				return response;
			})
			.catch(function (error) {
				push("api_error", {
					type: "fetch",
					url: url,
					method: method,
					body: typeof body === "string" ? body : "[object Object]",
					status: 0,
					statusText: error.message,
					response: "",
					duration: now() - startTime,
				});
				throw error;
			});
	};
}

function hookXHR() {
	if (typeof XMLHttpRequest === "undefined") return;
	var originalOpen = XMLHttpRequest.prototype.open;
	var originalSend = XMLHttpRequest.prototype.send;

	XMLHttpRequest.prototype.open = function (method, url) {
		this._monitor_url = url;
		this._monitor_method = method;
		this._monitor_start_time = now();
		return originalOpen.apply(this, arguments);
	};

	XMLHttpRequest.prototype.send = function (body) {
		// 排除上报接口
		if (this._monitor_url && cfg.endpoint && this._monitor_url.indexOf(cfg.endpoint) !== -1) {
			return originalSend.apply(this, arguments);
		}

		// 域名过滤
		if (isIgnoredDomain(this._monitor_url)) {
			return originalSend.apply(this, arguments);
		}

		this._monitor_body = body;

		var self = this;
		function onLoaded() {
			if (self.status >= 400 || self.status === 0) {
				// 忽略特定状态码
				if (isIgnoredStatus(self.status)) return;

				var responseData = "";
				try {
					if (self.responseType === "" || self.responseType === "text") {
						responseData = self.responseText;
					} else if (self.responseType === "json") {
						responseData = JSON.stringify(self.response);
					}
				} catch (e) {}

				push("api_error", {
					type: "xhr",
					url: self._monitor_url,
					method: self._monitor_method,
					body: self._monitor_body,
					status: self.status,
					statusText: self.statusText,
					response: responseData,
					duration: now() - self._monitor_start_time,
				});
			}
		}

		if ("addEventListener" in this) {
			this.addEventListener("loadend", onLoaded);
		} else {
			var _onreadystatechange = this.onreadystatechange;
			this.onreadystatechange = function () {
				if (this.readyState === 4) {
					onLoaded();
				}
				if (_onreadystatechange) {
					_onreadystatechange.apply(this, arguments);
				}
			};
		}

		return originalSend.apply(this, arguments);
	};
}

// 监听逻辑
function auto() {
	if (typeof window === "undefined") return;

	// 1. JS Error
	if (cfg.enable.jsError) {
		window.addEventListener(
			"error",
			function (e) {
				var t = e.target;
				// 区分资源错误和JS错误
				if (
					t &&
					t.tagName &&
					(t.tagName === "IMG" || t.tagName === "SCRIPT" || t.tagName === "LINK")
				) {
					if (cfg.enable.resourceError) {
						var src = t.tagName === "LINK" ? t.href : t.src;
						// 过滤忽略的资源路径
						if (isIgnoredResource(src)) return;
						// 过滤忽略的域名
						if (isIgnoredDomain(src)) return;

						push("resource_error", { tag: t.tagName, src: src, cdn: isCdn(src) });
					}
				} else {
					// JS 错误
					if (isIgnoredError(e.message)) return;
					// 尝试过滤 JS 文件域名 (可选)
					if (e.filename && isIgnoredDomain(e.filename)) return;

					var stack = e.error && e.error.stack ? String(e.error.stack).slice(0, 1000) : "";
					// 尝试过滤 stack 中的域名
					if (isIgnoredByContent(stack)) return;

					push("js_error", {
						message: e.message,
						filename: e.filename,
						lineno: e.lineno,
						colno: e.colno,
						stack: stack,
					});
				}
			},
			true
		); // 捕获阶段，为了拿到资源错误
	}

	// 2. Promise Rejection
	if (cfg.enable.promiseRejection) {
		window.addEventListener("unhandledrejection", function (e) {
			var r = e.reason || {};
			var msg = typeof r === "string" ? r : r.message;
			var st = r && r.stack ? String(r.stack).slice(0, 1000) : "";
			if (isIgnoredError(msg)) return;
			// 尝试过滤 message 或 stack 中的域名
			if (isIgnoredByContent(msg) || isIgnoredByContent(st)) return;
			push("promise_rejection", { message: msg, stack: st });
		});
	}

	// 3. API Error
	if (cfg.enable.apiError) {
		hookFetch();
		hookXHR();
	}
}

function init(options) {
	options = options || {};
	for (var k in options) {
		if (Object.prototype.hasOwnProperty.call(options, k)) {
			if (k === "enable") cfg[k] = Object.assign(cfg[k], options[k]);
			else cfg[k] = options[k];
		}
	}
	auto();
}

export default { init: init };
